import { Bindi, Reveal, SectionHeading } from "@/components/motifs";
import { PILLARS } from "@/content/chapters";

export const PracticeChapter = ({ headingAs }) => (
  <section id="practice" className="paper-surface border-y border-border" data-testid="practice-section">
    <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <SectionHeading number="04" title="The Practice" note="How the work is made" as={headingAs} />
      <div className="grid gap-px overflow-hidden border border-border bg-border sm:grid-cols-2 lg:grid-cols-4">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={0.07 * i} className="bg-background">
            <div className="group flex h-full flex-col p-8 transition-colors duration-500 hover:bg-paper">
              <div className="flex items-center justify-between">
                <span className="font-serif text-3xl italic text-foreground/25 transition-colors duration-500 group-hover:text-accent">
                  {p.no}
                </span>
                <Bindi size={7} className="opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              </div>
              <h3 className="mt-10 font-serif text-2xl font-medium tracking-tight">{p.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
